import cn from "classnames";
import React from "react";

import { MessageID } from "../../i18n/types";
import { LocalisedText } from "../../i18n";

import styles from "./style.module.scss";

interface ModalHeaderProps {
  className?: string;
  title: MessageID;
  isCloseButtonDisabled: boolean;
  hideCloseButton?: boolean;
  onCloseButtonClicked?: () => void;
}

const ModalHeader: React.FC<ModalHeaderProps> = (props: ModalHeaderProps) => {
  const {
    className,
    title,
    isCloseButtonDisabled,
    onCloseButtonClicked,
    hideCloseButton,
  } = props;
  return (
    <div className={cn(styles.header, className)}>
      <div className={styles.headerTitle}>
        <LocalisedText id={title} />
      </div>
      {!hideCloseButton && (
        <button
          className={styles.closeButton}
          onClick={onCloseButtonClicked}
          disabled={isCloseButtonDisabled}
        />
      )}
    </div>
  );
};

export default ModalHeader;
